import { createSelector } from "reselect";
import { initalSearchState } from "./../../reducers/Search/reducer";
import { IONICWrapper } from "../../utils/common";

const selectData = (state: any) => state.search;

export const makeSearch = () =>
  createSelector(
    selectData,
    (search) => search.loads || initalSearchState.loads
  );

export const getBuyLoadApiError = () =>
  createSelector(
    selectData,
    (search) =>
      search.showBuyLoadAPIError || initalSearchState.showBuyLoadAPIError
  );

export const countryStateCodesSelector = () =>
  createSelector(selectData, (search) => search.countryCodes);

export const makeStofLoads = () =>
  createSelector(
    selectData,
    (search) =>
      (search && search.stofLoads && search.stofLoads.loadPostings) || []
  );

export const isStofLoaded = () =>
  createSelector(
    selectData,
    (search) =>
      (search && search.stofLoads && search.stofLoads.isStofLoaded) || false
  );

export const makeStofTotalLoads = () =>
  createSelector(
    selectData,
    (search) =>
      (search && search.stofLoads && search.stofLoads.totalRecords) || []
  );

export const getOffSet = () => {
  const originDateDefaultOffset = IONICWrapper.details.getKeyValuePairs("originDateDefaultOffset");
  const destinationDateDefaultOffset = IONICWrapper.details.getKeyValuePairs("destinationDateDefaultOffset");
  return createSelector(selectData, (search) => {
    if (originDateDefaultOffset && destinationDateDefaultOffset) {
      return { originDateDefaultOffset, destinationDateDefaultOffset }
    }
    return search && search.offset
  });
}
